import {TextField, withStyles} from "@material-ui/core";

const   CustomFilter = withStyles({
    root: {
        '& label.Mui-focused': {
            color: '#FD349C'
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: '#FD349CF',
            borderBottomWidth: 2
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#FD349C'
        },
        '& .MuiInputBase-input.Mui-disabled': {
            color: '#000000'
        },
        '& .MuiInput-underline.Mui-disabled:before': {
            borderBottomStyle: 'none'
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottomColor: '#FD349C'
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#FD349C'
            }
        },
        '& .MuiSelect-select': {
            width: '100%'
        }
    }
})(TextField);

export default CustomFilter;
